import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import './assets/app.css';
import 'leaflet/dist/leaflet.css'

const savedTheme = localStorage.getItem('theme') || 'light';
if (savedTheme === 'dark') {
    document.documentElement.classList.add('dark');
} else {
    document.documentElement.classList.remove('dark');
}

axios.defaults.withCredentials = true;
axios.defaults.baseURL = 'http://localhost:8880';

const pinia = createPinia();
pinia.use(piniaPersistedstate);
const app = createApp(App);

app.use(pinia);
app.use(router);
app.mount('#app');


import { useAuthStore } from '@/stores/authStore';

const authStore = useAuthStore();

let consecutive403Errors = 0;

axios.interceptors.response.use(
  response => {
    consecutive403Errors = 0;
    return response;
  },
  async error => {
    const status = error.response ? error.response.status : null;

    if (status === 403) {
      consecutive403Errors += 1;
      console.warn(`Wykryto błąd 403: liczba kolejnych błędów 403 = ${consecutive403Errors}`);

      if (consecutive403Errors >= 3) {
        console.warn('Otrzymano 2 błędy 403 z rzędu. Wylogowywanie użytkownika...');

        await authStore.logout(false);

        router.push({ path: '/login', query: { sessionExpired: true } });
      }
    }

    return Promise.reject(error);
  }
);
